import React from "react";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import DashboardHeroSection from "components/dashboard/DashboardHeroSection";
import LabResultTable from "components/dashboard/lab-result/LabResultTable";
import UserAuth from "components/AuthGaurd/UserAuth";

const LabResult = () => {
  return (
    <UserAuth>
      <div className="tw-relative">
        <header>
          <Header admin={true} />
        </header>
        <section>
          <DashboardHeroSection title="Lab Result">
            <LabResultTable />
          </DashboardHeroSection>
        </section>

        <footer className="tw-flex">
          <Footer />
        </footer>
      </div>
    </UserAuth>
  );
};

export default LabResult;
